import { createTheme } from '@mui/material/styles';
import { Components } from '@mui/material/styles/components';
import { ControllerDialogColor } from '../../palette';
import { ControllerFont } from '../../fonts';

const theme = createTheme();

export const DialogComponent: Components = {
  MuiDialog: {
    styleOverrides: {
      root: {},
      paper: {
        maxWidth: '30vw',
        minWidth: 480,
        borderRadius: theme.spacing(0.25),
        boxShadow: `0px 4px 8px 0px ${ControllerDialogColor.BoxShadow}`,
        padding: theme.spacing(1, 2, 2, 2),
      },
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        padding: 0,
        fontSize: '20px',
      },
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: theme.spacing(0.5, 0),
      },
    },
  },
  MuiDialogContentText: {
    styleOverrides: {
      root: {
        color: String(ControllerDialogColor.DefaultFg),
        ...ControllerFont.Body400R,
        marginBottom: 0,
      },
    },
  },
};
